import { useContext } from 'react'
import { CurrencyContext } from '../providers/CurrencyProvider'

export const useCurrency = () => {
    return useContext(CurrencyContext)
}
